import React from "react";
import HeaderBrand from "./components/HeaderBrand";
import HeaderItems from "./components/HeaderItems";
import HeaderLogin from "./components/HeaderLogin";

export default () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light border-bottom ">
      
      <HeaderItems />
    </nav>
  );
};
